import { Injectable, Injector } from '@angular/core';
import { GenericApiService } from 'shared/services';
import { CodeModel } from '../definition/code.model';
import { CodeTypeService } from './code-type.service';

@Injectable({
  providedIn: 'root'
})
export class CodeApiService extends GenericApiService<CodeModel, any> {

  constructor(
    injector: Injector,
    private codeTypeService: CodeTypeService
  ) {
    super(injector, "CodeManagement");
  }

  codeTypes$ = this.codeTypeService.getList();

  /*根据类型获取字典列表*/
  getCodeListByType(typeName: string) {
    return this.httpClient.get(`${this.apiUrl}/GetCodeList/${typeName}`);
  }

  checkRelatedRelation(id:string){
    return this.httpClient.get(`${this.apiUrl}/CheckRelatedRelation/${id}`)
  }
}